import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.match";
/**
 * Created by commyfeng on 2017/3/21.
 */
import { isNewQQLogin } from '@tencent/vft-common/login';
import { buildCSRF } from '@tencent/vft-common/login/lib';
import RequestErrorType from "../lib/RequestErrorType";
import RequestError from "../lib/RequestError";
var IS_STD_PROTOCOL = typeof window !== 'undefined' ? /^(https:|http:)/.test(location.protocol) : false;
var HTTP2HTTP_APPID = '68106135';
var HTTP2HTTP_SECRETKEY = 'e667570eb833960cc41051d498df1c233308eb195dba2cc3';
function jsonp(url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (isNewQQLogin() && url.match(/\/\/pay.video.qq.com/)) {
    // QQ互联迁移
    url = url.replace(/\/\/(pay.video.qq.com)/, '//access.video.qq.com/trans/$1');
    if (!$.isPlainObject(data)) {
      data = {};
    }
    var csrfParam = buildCSRF();
    $.extend(data, {
      vappid: HTTP2HTTP_APPID,
      vsecret: HTTP2HTTP_SECRETKEY
    }, csrfParam);
  }
  if (!IS_STD_PROTOCOL) {
    url = url.replace(/^(\w+:)?/, 'https:');
  }
  return new Promise(function (resolve, reject) {
    $.ajax($.extend({
      url: url,
      dataType: "jsonp",
      data: data,
      success: function success(json) {
        if (json) {
          resolve(json);
        } else {
          reject(new RequestError(0, '服务器开小差了！请重试', null, RequestErrorType.NETWORK_ERR));
        }
      },
      error: function error(xhr, errType) {
        if (errType === 'parsererror' && xhr.status === 200) {
          try {
            var _data = parse(xhr.response);
            resolve(_data);
          } catch (e) {
            reject(new RequestError(0, '请求解析出错！请重试', null, RequestErrorType.NETWORK_ERR));
          }
        } else if (errType == 'timeout') {
          reject(new RequestError(1, '网络返回超时！请重试', null, RequestErrorType.NETWORK_ERR));
        } else {
          reject(new RequestError(0, '网络开小差了！请重试', null, RequestErrorType.NETWORK_ERR));
        }
      }
    }, options));
  });
}
function parse(data) {
  data = new Function('return ' + data)();
  return data;
}
export default function () {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof $ === 'undefined')) {
              _context.next = 2;
              break;
            }
            throw new Error('需要在页面中引入zepto');
          case 2:
            _context.next = 4;
            return jsonp(this.request.url, this.request.data, this.request.options);
          case 4:
            this.response = _context.sent;
          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
}